import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/blog/life-sciences-digitization-roadmap")({
  head: () => buildRouteHead("/es/blog/life-sciences-digitization-roadmap", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/blog/life-sciences-digitization-roadmap", replace: true });
  },
});
